import React, { useEffect, useState, useCallback } from 'react'
import firebase from '../firebase'
import { Avatar } from '@material-ui/core'
import StorageIcon from '@material-ui/icons/Storage'
import withStyles from '@material-ui/core/styles/withStyles'
import { isMobile, deviceType, withOrientationChange } from 'react-device-detect'
import { useLocation } from 'react-router-dom'
import { useGlobalState } from "../useGlobalState"

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block',
        position: 'absolute',
        right: '50%',
        marginTop: theme.spacing(0.5),
        [theme.breakpoints.down(480)]: {
            marginRight: theme.spacing(0.5),
        },
    },
    logo: {
        width: '50',
        marginRight: -20,
        [theme.breakpoints.down(480)]: {
            marginRight: theme.spacing(0.5),
            right: -28,
        },
    },
    logoLogged: {
        width: '50',
        marginRight: -20,
        [theme.breakpoints.down(480)]: {
            marginRight: theme.spacing(0.5),
            right: -28,
        },
    },
    logoMobile: {
        width: '50',
        marginRight: -24,
    },
    logoLandscape: {
        width: '50',
        marginRight: -20,
    },
    logoTablet: {
        width: '50',
        marginRight: -20,
    },
})

const Logo = (props) => {
    const { classes } = props
    const [logo, setLogo] = useState('')
    const [{ applogo }, dispatch] = useGlobalState()
    const [isLogged, setIsLogged] = useState(false)
    const { isLandscape } = props
    const location = useLocation()

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            setIsLogged(true)
        } else {
            setIsLogged(false)
        }
    }, [])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            setIsLogged(true)
        } else {
            setIsLogged(false)
        }
    }, [location.pathname])

    const stableDispatch = useCallback(dispatch, [])
    useEffect(() => {
        if (!applogo.logosrc) {
            firebase.db.collection('backupsettings').doc('settings').get()
                .then((doc) => {
                    if (doc.exists) {
                        stableDispatch({
                            type: 'changeLogo',
                            newTheme: { logosrc: doc.data().logo }
                        })
                        setLogo(doc.data().logo)
                    } else {
                        setLogo(false)
                    }
                })
        } else {
            setLogo(applogo.logosrc)
        }
    }, [stableDispatch, applogo.logosrc])

    return (
        <main className={classes.main}>
            {!isLogged ?
                <div>
                    {!logo ?
                        <Avatar className={classes.logo}>
                            <StorageIcon />
                        </Avatar>
                        :
                        <Avatar className={classes.logo} src={applogo.logosrc} variant="square" alt="Logo" />
                    }
                </div>
                :
                <div>
                    {!logo ?
                        <span>
                            {!isMobile ?
                                <Avatar className={classes.logoLogged}>
                                    <StorageIcon />
                                </Avatar>
                                : isMobile && deviceType === 'tablet' ?
                                    <Avatar className={classes.logoTablet}>
                                        <StorageIcon />
                                    </Avatar>
                                    : isMobile && isLandscape && deviceType !== 'tablet' ?
                                        <Avatar className={classes.logoLandscape}>
                                            <StorageIcon />
                                        </Avatar>
                                        :
                                        <Avatar className={classes.logoMobile}>
                                            <StorageIcon />
                                        </Avatar>
                            }
                        </span>
                        :
                        <span>
                            {!isMobile ?
                                <Avatar className={classes.logoLogged} src={applogo.logosrc} variant="square" alt="Logo" />
                                : isMobile && deviceType === 'tablet' ?
                                    <Avatar className={classes.logoTablet} src={applogo.logosrc} variant="square" alt="Logo" />
                                    : isMobile && isLandscape && deviceType !== 'tablet' ?
                                        <Avatar className={classes.logoLandscape} src={applogo.logosrc} variant="square" alt="Logo" />
                                        :
                                        <Avatar className={classes.logoMobile} src={applogo.logosrc} variant="square" alt="Logo" />
                            }
                        </span>
                    }
                </div>
            }
        </main>
    )
}

export default withOrientationChange(withStyles(styles)(Logo))